export default __webpack_public_path__ + "static/media/medaille-bdo-cap-realisation.02b1dc0e.png";